import { InvoiceSendingState } from '@features/invoicesLegacy/types/invoiceSendingState'

export const sendingStateToMessageTKey: Partial<Record<InvoiceSendingState, string | null>> = {
  signedoff: 'einvoce.status.description.signedoff',
}
